import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface modelSurfaceState {
  country_codes: Array<string>;
  indicator_ids: Array<string>;
  surveys: Array<any>;
  selectedSurvey: any;
  selectedIndicator: any;
  indicatorInfoObj: any;
}

const initialState: modelSurfaceState = {
  country_codes: [],
  indicator_ids: [],
  surveys: [],
  selectedSurvey: {},
  selectedIndicator: {},
  indicatorInfoObj: {},
};

export const modelSurfaceSlice = createSlice({
  name: 'modelSurfaceSlice',
  initialState,
  reducers: {
    populateData: (state, action: PayloadAction<any>) => {
      state.country_codes = action.payload.all_country_codes;
      state.indicator_ids = action.payload.all_indicator_ids;
      state.surveys = action.payload.surveys;
    },
    setSelectedSurvey: (state, action: PayloadAction<object>) => {
      state.selectedSurvey = action.payload;
    },
    setSelectedIndicator: (state, action: PayloadAction<object>) => {
      state.selectedIndicator = action.payload;
    },
    setIndicatorInfoObj: (state, action: PayloadAction<object>) => {
      state.indicatorInfoObj = action.payload;
    },
  },
});

export const { populateData, setSelectedIndicator, setSelectedSurvey, setIndicatorInfoObj } = modelSurfaceSlice.actions;
export const indicator_ids = (state: RootState) => state.modelSurfaceSlice.indicator_ids;
export const surveys = (state: RootState) => state.modelSurfaceSlice.surveys;
export const selectedSurvey = (state: RootState) => state.modelSurfaceSlice.selectedSurvey;
export const selectedIndicator = (state: RootState) => state.modelSurfaceSlice.selectedIndicator;
export const indicatorInfoObj = (state: RootState) => state.modelSurfaceSlice.indicatorInfoObj;
export default modelSurfaceSlice.reducer;
